export default __webpack_public_path__ + "static/media/CrossCircle.eba20e95.svg";